import { getErrorReporter } from 'shared/services/error-tracking';
import { PushRegistrationError } from 'shared/types/electron';
import { ID } from 'shared/types/id';

import { fetchFreshPushToken } from './fetch-fresh-push-token';
import { getPushNotificationToken } from './helpers';

export const getPushToken = async (uid: ID) => {
  if (!uid) {
    return;
  }

  try {
    return getPushNotificationToken(uid) ?? (await fetchFreshPushToken());
  } catch (error) {
    getErrorReporter().captureException(error, {
      tags: {
        source: 'get-push-token',
        ...(error instanceof PushRegistrationError && { code: error.code }),
      },
    });
  }
};
